import { useDispatch, useSelector } from "react-redux";
import { useCountriesQuery, usePlatformsQuery } from "src/context/api/filters/api";
import { useSearchTermsFiltersQuery } from "src/context/api/non-branded/api";
import { useCurrentWorkspace } from "src/context/reducers/app-settings";
import { RootState } from "src/context/store";
import { fDate } from "src/utils/format-time";
import { setFilterLoadedKeyword } from "src/context/reducers/filter-settings/filterSlice";
import { useEffect } from "react";
import { SearchTermsFilterItem } from "src/context/api/non-branded/models";
import { alpha, Card, CardContent, CardHeader, Stack } from "@mui/material";
import SearchTermsGrid from "./data-grid/search-terms-grid";
import TopOpportunities from "./top-opportunities";

export default function NonBrandedOverviewSection() {
    const dispatch = useDispatch();
    const workspace = useCurrentWorkspace();
    const filterStore = useSelector((state: RootState) => state.filters);
    const { data: searchTermsFilters } = useSearchTermsFiltersQuery({
        workspace_id: workspace?.id as number,
        start_date: fDate(filterStore.start, "yyyy-MM-dd"),
        end_date: fDate(filterStore.end, "yyyy-MM-dd"),
        devices: filterStore.devices,
        countries: filterStore.countries,
        platforms: filterStore.platforms,
    }, { skip: !workspace?.id });


    useEffect(() => {
        if (searchTermsFilters) {
            dispatch(setFilterLoadedKeyword(
                searchTermsFilters.map(
                    (term: SearchTermsFilterItem) => ({
                        search_term: term.search_term,
                        total_organic_searches: term.total_clicks
                    })),
            )
            );
        }
    }, [searchTermsFilters]);

    return (
        <Stack direction={"column"} spacing={2}>
            <Stack
                direction="row"
                spacing={2}
            >
                <Stack width="100%" borderRadius={2} p={2} bgcolor="background.paper" height="250px">

                </Stack>
                <Stack width="100%" borderRadius={2} p={2} bgcolor="background.paper" height="250px">

                </Stack>
                <Stack width="100%" borderRadius={2} p={2} bgcolor="background.paper" height="250px">

                </Stack>
            </Stack>
            <Stack sx={{ backgroundColor: "#1C252E" }} width="100%" borderRadius={2} p={0} m={0} bgcolor="background.paper">
                <TopOpportunities />
            </Stack>
            <Stack>
                <SearchTermsGrid />
            </Stack>
        </Stack>
    );
}